var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 166,
    viewBox: "0 0 166 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1428 72.4286C43.1428 54.5977 57.5977 40.1429 75.4286 40.1429C93.2594 40.1429 107.714 54.5977 107.714 72.4286C107.714 90.2594 93.2594 104.714 75.4286 104.714C57.5977 104.714 43.1428 90.2594 43.1428 72.4286ZM75.4286 24C48.6822 24 27 45.6822 27 72.4286C27 99.1749 48.6822 120.857 75.4286 120.857C84.4949 120.857 92.9793 118.366 100.235 114.03L126.221 140.017C129.373 143.169 134.484 143.169 137.636 140.017C140.788 136.865 140.788 131.754 137.636 128.602L112.557 103.523C119.61 95.1107 123.857 84.2656 123.857 72.4286C123.857 45.6822 102.175 24 75.4286 24Z",
    fill: "#FF9B50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.2c0ab592ade7a45f66f2b84823d1e5dc.svg";
export { ForwardRef as ReactComponent };